import { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CardHeader from '@mui/material/CardHeader';
import {Button,Typography,Box} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
//import StrategyModalView from '../Modals/StrategyModal/StrategyModal_View'
import StrategyViewDialogEdit from '../../components/Modals/StrategyModal/StrategyModal_Edit'
import { UserContext } from '../../context/UserContext'
import Iconify from '../../common/Iconify/Iconify';
import ErrorMessage from '../../common/ErrorMessage/ErrorMessage'
import BarChartModalEdit from '../../components/Modals/BarchartModal/BarchartModal_Edit';

// ----------------------------------------------------------------------
//export default function StrategiesList({ title, subheader, list, ...others }) {

export default function StrategiesList({ title, subheader, list, id_client,onSubmitReloadAll }) {
  
  const [selected, setSelected] = useState(['2']);
  const id_strategy_default = 0
  const type_request = 3
  const [viewopen, setViewOpen] = useState(null);

  const handleClickComplete = (taskId) => {
    const tasksCompleted = selected.includes(taskId)
      ? selected.filter((value) => value !== taskId)
      : [...selected, taskId];

    setSelected(tasksCompleted);
  };

  const handleOpenView = () => {
    setViewOpen(true);
  }

  const handleCloseStrategyCreate = () => {
    setViewOpen(false);
  };

  const onSubmitRefreshAction = (trigger) => {
    if (trigger) {
      onSubmitReloadAll(trigger)
      handleCloseStrategyCreate()
    }
  }
  return (
    <Card
    sx={{
      '& .MuiStack-root': {backgroundColor: '#231E39', color: 'gray', fontStyle:'oblique', fontSize:'11px'},
      '& .MuiBox-root' : {backgroundColor: '#231E39'},
      '& .MuiCardHeader-root' : {color: 'white'},
      '& .MuiButton-text' : {color: 'var(--main-color)'},
      '& .MuiIconButton-root' : {color: 'white'},
     
      }} 
    >
      <Box
          sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 0,  // Adjust padding as needed
        }}
        
      >
        <CardHeader title={title} subheader={subheader} />
        <Button 
          sx={{
                paddingRight: '1.5rem',
                marginRight: '1.5rem',
                border: '1px solid var(--main-color)'
              }}
          startIcon={<Iconify icon="eva:plus-fill"/>}
          onClick={handleOpenView}
        >
          Create New Strategy
        </Button>
        <StrategyViewDialogEdit open={viewopen} handleClose={handleCloseStrategyCreate} id_client={id_client} id_strategy= {id_strategy_default} type_request={type_request} onSubmitRefresh = {onSubmitRefreshAction}/>
      </Box>

      {
        /*list.map((commitment) => (
        
        <TaskItem
          key={commitment.ID_Strategy}
          task={commitment}
          id_client = {id_client}
          checked={selected.includes(commitment.ID_Strategy)}
          onChange={() => handleClickComplete(commitment.ID_Strategy)}
          onSubmitRefresh = {onSubmitRefreshAction}
        />
        ))*/

        list
            .filter((commitment) => commitment.ID_Strategy !== 0)
            .map((commitment) => (
              <TaskItem
                key={commitment.ID_Strategy}
                task={commitment}
                id_client={id_client}
                checked={selected.includes(commitment.ID_Strategy)}
                onChange={() => handleClickComplete(commitment.ID_Strategy)}
                onSubmitRefresh={onSubmitRefreshAction}
              />
        ))
      }
      
    </Card>
  );
}

StrategiesList.propTypes = {
  list: PropTypes.array,
  subheader: PropTypes.string,
  title: PropTypes.string,
};

// ----------------------------------------------------------------------

function TaskItem({ key, task, id_client,checked,onChange,onSubmitRefresh }) {

  const [open, setOpen] = useState(null);
  const [viewopen, setViewOpen] = useState(null);
  const [viewopenprogress,setViewOpenProgress] = useState(null);
  const [typerequest, setTypeRequest] = useState(0);
  const [login, setLogin] = useContext(UserContext);
  const isLoggedIn = login.isLoggedIn
  const [activeModal, setActiveModal] = useState(false);
  const [idstrategy, setIdStrategy] = useState(null);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    
  };

  const handleCloseStrategyView = () => {
    setViewOpen(false);
    handleCloseMenu()
  };

  const handleOpenView = async (e,idstrategy,type) => {
    e.stopPropagation();
    setIdStrategy(idstrategy);
    setViewOpen(true);
    setTypeRequest(type)
    console.log('type selected:')
    console.log(type)
  }

  const handleOpenEditProgress = async (e,idstrategy,type) => {
    e.stopPropagation();
    setIdStrategy(idstrategy);
    setTypeRequest(type);
    setViewOpenProgress(true);
    
  }

  const handleCloseProgressEdit = () => {
    setViewOpenProgress(false);
    handleCloseMenu()
    
  }
  const onSubmitRefreshAction = (trigger) => {
    if (trigger) {
      onSubmitRefresh(trigger)
      handleCloseStrategyView()
    }
  }
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          pl: 2,
          pr: 1,
          py: 1,
          '&:not(:last-of-type)': {
            borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
          },
        }}
      >
       
        <Typography
          //onClick={handleEdit} // Add click handler here
          sx={{ flexGrow: 1, m: 0, cursor: 'pointer' }}
        >
          {task.Desc_Strategy}
        </Typography>

        <IconButton color={open ? 'inherit' : 'default'} onClick={handleOpenMenu}>
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>
      </Stack>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
      
        <MenuItem onClick={(e) => handleOpenView(e,task.ID_Strategy,0)}>       
          <Iconify icon="carbon:view-filled" sx={{ mr: 2 }} />
          View details
        </MenuItem>
        <MenuItem onClick={(e) => handleOpenView(e,task.ID_Strategy,1)}>       
          <Iconify icon="solar:pen-bold" sx={{ mr: 2 }} />
          Edit strategy
        </MenuItem>
        <MenuItem onClick={(e) => handleOpenEditProgress(e,task.ID_Strategy,0)}>       
          <Iconify icon="bi:bar-chart-line-fill" sx={{ mr: 2 }} />
          View Progress
        </MenuItem>
        <MenuItem onClick={(e) => handleOpenEditProgress(e,task.ID_Strategy,1)}>       
          <Iconify icon="tdesign:chart-line-data-1" sx={{ mr: 2 }} />
          Report Progress
        </MenuItem>
        <MenuItem onClick={(e) => handleOpenView(e,task.ID_Strategy,2)} sx={{ color: 'error.main' }}>
          <Iconify icon="solar:trash-bin-trash-bold" sx={{ mr: 2 }} />
          Delete
        </MenuItem>

        <StrategyViewDialogEdit open={viewopen} handleClose={handleCloseStrategyView} id_client={id_client} id_strategy={idstrategy} type_request={typerequest} onSubmitRefresh={onSubmitRefreshAction}/>    
        <BarChartModalEdit 
          open={viewopenprogress} 
          handleClose={handleCloseProgressEdit} 
          id_client={id_client} 
          id_strategy={idstrategy}
          desc_strategy={task.Desc_Strategy}
          type_request={typerequest} 
          size = "lg" /> 
      </Popover>
    </>
  );
}

TaskItem.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  task: PropTypes.object,
};